import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import BasePickerComponent from '../BasePickerComponent';
import CalendarComponent from './CalendarComponent';
import { NextButton, PreviousButton } from '../../../../buttons/DirectionButton';

import {
  monthNames,
  getPreviousMonthYear,
  getNextMonthYear,
  getSteppedMonthYear,
  parseN,
} from '../utils';
import useStyles from './styles';


const DatePickerComponent = ({
  value, onClose, onProceed, setDate,
}) => {
  const { t } = useTranslation(['translation']);
  const classes = useStyles();
  const [originalYear, originalMonth, originalDay] = value.split('-').map(Number);

  const [year, setYear] = useState(originalYear);
  const [month, setMonth] = useState(originalMonth);
  const monthName = monthNames[month];
  const [day, setDay] = useState(originalDay);

  const originalCalendarPosition =
    year === originalYear && month === originalMonth;

  const setPreviousMonth = () => {
    const { month: newMonth, year: newYear } = getPreviousMonthYear({ month, year });
    setMonth(newMonth);
    setYear(newYear);
  };

  const setNextMonth = () => {
    const { month: newMonth, year: newYear } = getNextMonthYear({ month, year });
    setMonth(newMonth);
    setYear(newYear);
  };

  const selectDay = (newDay, step = 0) => {
    const { month: newMonth, year: newYear } = getSteppedMonthYear({ month, year, step });
    setDate(`${parseN(newYear)}-${parseN(newMonth)}-${parseN(newDay)}`);
    setDay(newDay);
    setMonth(newMonth);
    setYear(newYear);
  };

  return (
    <BasePickerComponent
      title={t('COMMON.DATE_PICKER.TITLE')}
      primaryButtonText={t('COMMON.DATE_PICKER.PRIMARY_BUTTON_TEXT')}
      secondaryButtonText={t('COMMON.DATE_PICKER.SECONDARY_BUTTON_TEXT')}
      onSecondaryClick={onClose}
      onPrimaryClick={onProceed}
    >
      <div>
        <div className={classes.calendarHeader}>
          <PreviousButton onClick={setPreviousMonth} />
          <span>{`${monthName} ${year}`}</span>
          <NextButton onClick={setNextMonth} />
        </div>
        <CalendarComponent
          year={year}
          month={month}
          day={day}
          originalPosition={originalCalendarPosition}
          selectDay={selectDay}
        />
      </div>
    </BasePickerComponent>
  );
};

DatePickerComponent.propTypes = {
  value: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onProceed: PropTypes.func.isRequired,
  setDate: PropTypes.func.isRequired,
};

export default DatePickerComponent;
